export const StoreFeatures = {
  User: 'user',
  General: 'general',
  Cms: 'cms',
  Subscription: 'subscription',
};
